import { render, staticRenderFns } from "./UserEditComponent.vue?vue&type=template&id=2d524748&scoped=true"
import script from "./UserEditComponent.vue?vue&type=script&lang=js"
export * from "./UserEditComponent.vue?vue&type=script&lang=js"
import style0 from "./UserEditComponent.vue?vue&type=style&index=0&id=2d524748&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d524748",
  null
  
)

export default component.exports